<template>
<b-overlay :show="loading">
  <AuthWrapper>
    <template #card>
      <div class="text-center">
        <div>
          <h2>PENT ACCESS CONTROL</h2>
        </div>

        <div>
          <p>Fill the form below to get started</p>
        </div>
      </div>

      <div>
        <validation-observer ref="registerForm" #default="{invalid}">
          <b-form @submit.prevent="signup">
            <b-form-group label="First Name" label-for="first_name">
              <validation-provider #default="{ errors }" name="First Name" rules="required" vid="first_name">
                <div class="custom-input">
                  <span class="leading">
                    <feather-icon icon="UserIcon" size="20" />
                  </span>

                  <input id="first_name" v-model="registration.first_name" name="first_name" placeholder="" />
                </div>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group label="Last Name" label-for="last_name">
              <validation-provider #default="{ errors }" name="Last Name" rules="required" vid="last_name">
                <div class="custom-input">
                  <span class="leading">
                    <feather-icon icon="UserIcon" size="20" />
                  </span>

                  <input id="last_name" v-model="registration.last_name" name="last_name" placeholder="" />
                </div>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group label="Email" label-for="email">
              <validation-provider #default="{ errors }" name="Email" rules="required|email" vid="email">
                <div class="custom-input">
                  <span class="leading">
                    <feather-icon icon="MailIcon" size="20" />
                  </span>
                  <input id="login-username" v-model="registration.email" type="email" name="register-email" placeholder="" />
                </div>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group label="Phone" label-for="phone">
              <validation-provider #default="{ errors }" name="Phone" rules="required|length:10" vid="phone">
                <div class="custom-input">
                  <span class="leading">
                    <feather-icon icon="PhoneIncomingIcon" size="20" />
                  </span>
                  <input id="phone" v-model="registration.phone" name="register-phone" placeholder="" />
                </div>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group label="Password" label-for="password">
              <validation-provider #default="{ errors }" name="Password" rules="required|password">
                <div class="custom-input">
                  <span class="leading">
                    <feather-icon icon="LockIcon" size="20" />
                  </span>

                  <input id="login-password" v-model="registration.password" :type="password1FieldType" placeholder="············">
                  <span class="trailing">
                    <feather-icon class="cursor-pointer" :icon="password1ToggleIcon" @click="togglePassword1Visibility" />
                  </span>
                </div>
                
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group label="Confirm Password" label-for="confirm-password">
              <validation-provider #default="{ errors }" name="Confirm Password" rules="required|confirmed:Password">
                <div class="custom-input">
                  <span class="leading">
                    <feather-icon icon="LockIcon" size="20" />
                  </span>

                  <input id="confirm-password" v-model="confirmPassword" :type="password2FieldType" placeholder="············">
                  <span class="trailing">
                    <feather-icon class="cursor-pointer" :icon="password2ToggleIcon" @click="togglePassword2Visibility" />
                  </span>
                </div>

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <div>
              <b-button class="py-1" type="submit" variant="primary" block :disabled="invalid">
                Sign Up
              </b-button>
            </div>

            <div class="text-center">
              <p class="pt-2"> Already have an account?
                <span>
                  <b-link :to="{ name:'auth-login' }">
                    <span>Sign In</span>
                  </b-link>
                </span>
              </p>
            </div>
          </b-form>
        </validation-observer>
      </div>
    </template>
  </AuthWrapper>
</b-overlay>
</template>

<script>
import {
  BAlert,
  BButton,
  BCard,
  BCardText,
  BCardTitle,
  BForm,
  BFormCheckbox,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BOverlay
} from 'bootstrap-vue'

import { get } from "lodash"
import { email, required } from '@validations';
import { togglePasswordVisibility } from '@core/mixins/ui/forms';
import { ValidationObserver, ValidationProvider } from 'vee-validate'

import BottomDesign from '@/assets/svg/BottomDesign.svg';
import PasswordLock from "@/assets/svg/PasswordLock.svg";
import RegistrationMail from "@/assets/svg/RegistrationMail.svg";
import RegistrationPhone from "@/assets/svg/RegistrationPhone.svg";

import AppLogo from '@core/layouts/components/Logo.vue';
import Rectangles from "@/pages/auth/shared-components/rectangles.vue";
import AuthWrapper from "@core/components/auth-wrapper/AuthWrapper.vue";
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    AuthWrapper,
    PasswordLock,
    RegistrationPhone,
    RegistrationMail,
    Rectangles,
    BottomDesign,
    BOverlay,
    BAlert,
    // BSV
    BCard,
    BLink,
    BCardTitle,
    BCardText,
    BForm,
    BFormSelect,
    BButton,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    BFormFile,
    // validations
    AppLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      loading: false,
      errorMessage: '',
      client_group_options: [],
      registration: {
        email: '',
        phone: '',
        password: '',
      },
      confirmPassword: '',

      // Toggle Password
      password1FieldType: 'password',
      password2FieldType: 'password',

      // validation rules
      required,
      email
    }
  },
  computed: {
    password1ToggleIcon() {
      return this.password1FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    password2ToggleIcon() {
      return this.password2FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  created() {
    const { referrer = null } = this.$route.query

    if (referrer) {
      this.registration.referrer = referrer;
      this.$router.replace({
        query: {}
      })
    }
  },
  methods: {
    async signup() {
      try {
        this.loading = true;
        this.errorMessage = '';

        const result = await this.$swal({
          title: 'Register account',
          text: "Have you confirmed that the information provided is correct?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, proceed.',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        });

        if (!result.value) {
          return;
        }

        const success = await this.$refs.registerForm.validate();
        if (!success) {
          return;
        }

        const formData = new FormData();

        Object.keys(this.registration).forEach(field_name => {
          formData.append(field_name, this.registration[field_name]);
        });

        const response = await this.useJwt().mainService.auth.register(formData);
        const response_data = response.data.data;

        const { access_token } = response_data;
        this.useJwt().mainService.auth.setToken(access_token)

        await this.$router.replace({ name: "home" }).catch(() => {});
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        this.errorMessage = error_message;

        if (error_message.includes("An account with this email already exists.")) {
          this.$refs.registerForm.setErrors({
            email: [error_message]
          });
        }

        if (error_message.includes("An account with this phone number already exists.")) {
          this.$refs.registerForm.setErrors({
            phone: [error_message]
          });
        }

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false
      }
    },
    togglePassword1Visibility() {
      this.password1FieldType = this.password1FieldType === 'password' ? 'text' : 'password'
    },
    togglePassword2Visibility() {
      this.password2FieldType = this.password2FieldType === 'password' ? 'text' : 'password'
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
